"use client";

/**
 * Fires bumpBlogView once per slug after the page mounts.
 * Renders nothing.
 */
import { useEffect } from "react";
import { bumpBlogView } from "../_actions";

export function ViewBumper({ slug }: { slug: string }) {
  useEffect(() => {
    bumpBlogView(slug);
    // Run only on slug change.
     
  }, [slug]);
  return null;
}
